import { string, number, object } from 'yup';

const schema = object().shape({
  name: string().required('Name is required'),
  branchId: number().required('Branch is required')
});

export default { create: schema, edit: schema };
